(function () {
  'use strict';

  var ITEM_KEY = 'msm-atc-item';
  var RECENT_KEY = 'msm-recently-viewed';
  var COLL_KEY = 'msm-recent-collections';
  var CARDS_SECTION = 'added-to-cart-recommendations';
  var moneyFormat = (window.Shopify && Shopify.money_format) || '${{amount}}';

  var root = document.querySelector('[data-atcp]');
  if (!root) return;

  function $(sel) { return root.querySelector(sel); }
  function $$(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  function money(cents) {
    if (cents == null) return '';
    if (window.Shopify && typeof Shopify.formatMoney === 'function') return Shopify.formatMoney(cents, moneyFormat);
    return '$' + (cents / 100).toFixed(2);
  }

  function imgUrl(src, size) {
    if (!src) return '';
    var s = src.indexOf('//') === 0 ? 'https:' + src : src;
    return s.replace(/(\.(?:jpg|jpeg|png|gif|webp))(\?.*)?$/i, '_' + size + 'x$1$2');
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function getJSON(storage, key) {
    try { return JSON.parse(storage.getItem(key)); } catch (e) { return null; }
  }

  var item = getJSON(sessionStorage, ITEM_KEY);

  // ---- Confirmation card ----------------------------------------------------
  function populateConfirm(it) {
    if (!it) return;
    var empty = $('[data-atcp-empty]');
    if (empty) empty.setAttribute('hidden', '');

    var img = $('[data-atcp-img]');
    var src = it.image || it.featured_image;
    if (img && src) {
      img.innerHTML = '<img src="' + esc(imgUrl(src, 160)) + '" alt="' + esc(it.product_title || it.title || '') + '">';
      if (it.url) img.setAttribute('href', it.url);
    }
    var nameEl = $('[data-atcp-name]');
    if (nameEl) nameEl.textContent = it.product_title || it.title || '';

    var optsEl = $('[data-atcp-opts]');
    if (optsEl) {
      var html = '';
      var opts = it.options_with_values || [];
      if (!it.product_has_only_default_variant && opts.length) {
        opts.forEach(function (o) {
          if (o && o.value) html += '<span>' + esc(o.name) + ': ' + esc(o.value) + '</span>';
        });
      }
      if (it.quantity && it.quantity > 1) html += '<span>Qty: ' + esc(it.quantity) + '</span>';
      optsEl.innerHTML = html;
    }
  }

  // ---- Cart summary (subtotal + checkout count) -----------------------------
  function refreshSummary(cart) {
    if (!cart) return;
    var sub = $('[data-atcp-subtotal]');
    if (sub) sub.textContent = money(cart.total_price);
    var cnt = $('[data-atcp-checkout-count]');
    if (cnt) cnt.textContent = cart.item_count || 0;
  }

  // Show the confirmation bar only when there's a just-added item AND the cart
  // still has something in it. Otherwise show the "got here directly" fallback
  // (also covers emptying the cart from the mini cart on this page).
  function setBarVisible(show) {
    var bar = $('[data-atcp-bar]');
    var empty = $('[data-atcp-empty]');
    if (bar) bar.style.display = show ? '' : 'none';
    if (empty) { if (show) empty.setAttribute('hidden', ''); else empty.removeAttribute('hidden'); }
  }

  function syncBar(itemCount) {
    if (item && itemCount > 0) setBarVisible(true);
    else setBarVisible(false);
  }

  // Initial cart count comes from the server-rendered checkout count.
  var initialCount = parseInt(($('[data-atcp-checkout-count]') || {}).textContent, 10) || 0;
  if (item && initialCount > 0) populateConfirm(item);
  syncBar(initialCount);

  // Keep the summary + bar visibility in sync with any cart change
  // (peek quantity edits, removals, adds).
  document.addEventListener('cart:updated', function (e) {
    if (!e || !e.detail) return;
    refreshSummary(e.detail);
    syncBar(e.detail.item_count || 0);
  });

  // In-place add (from this page's recommendation cards): refresh the card and
  // the cart everywhere instead of reloading.
  document.addEventListener('msm:atc-added', function (e) {
    var it = e && e.detail;
    if (it) { item = it; populateConfirm(it); }
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        refreshSummary(cart);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      })
      .catch(function () {});
  });

  // Re-run third-party widgets after injecting server-rendered cards.
  function hydrateCards(scope) {
    if (window.jdgm && typeof window.jdgm.customizeBadges === 'function') {
      try { window.jdgm.customizeBadges(); } catch (e) {}
    }
  }

  // ---- Recommendation blocks ------------------------------------------------
  // De-duplication is PER ROW only (a row never repeats a product, and never
  // shows the just-added product). Products may appear in more than one row,
  // which is expected for a small/niche catalog — global de-dupe would starve
  // later rows.

  function cardHandle(cardEl) {
    var a = cardEl.querySelector('a[href*="/products/"]');
    if (!a) return '';
    var m = (a.getAttribute('href') || '').split('?')[0].match(/\/products\/([^\/]+)/);
    return m ? m[1] : '';
  }

  var TARGET = 12; // how many cards each row tries to show

  // Append a fetched card list's products into a track, skipping repeats within
  // this row (seenRow) and anything past the target. Returns cards appended.
  function appendCards(list, track, seenRow) {
    var holder = document.createElement('div');
    holder.innerHTML = list.innerHTML;
    var cards = holder.querySelectorAll('[data-product-item]');
    var added = 0;
    for (var i = 0; i < cards.length; i++) {
      if (track.children.length >= TARGET) break;
      var h = cardHandle(cards[i]);
      if (!h || seenRow[h]) continue;
      seenRow[h] = true;
      track.appendChild(cards[i]);
      added++;
    }
    return added;
  }

  // Fill a row from a prioritized list of sources until it reaches TARGET cards
  // or sources run out. De-dupes within the row via seenRow.
  function fetchFill(urls, track, block, seenRow) {
    seenRow = seenRow || {};
    var i = 0;
    function step() {
      if (track.children.length >= TARGET || i >= urls.length) return finish();
      var url = urls[i++];
      if (!url) return step();
      return fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var list = doc.querySelector('[data-atcp-recs-list]');
          if (list) appendCards(list, track, seenRow);
          return step();
        })
        .catch(function () { return step(); });
    }
    function finish() {
      if (track.children.length) { block.removeAttribute('hidden'); hydrateCards(track); }
      return Promise.resolve(track.children.length > 0);
    }
    return step();
  }

  // Like fetchFill, but every URL is requested at once and the results are appended
  // in the order they were given. Used where the row's order is the point (recently
  // viewed is most-recent-first) and each URL yields exactly one card, so there is
  // nothing to be gained by walking them one at a time.
  function fetchAllOrdered(urls, track, block, seenRow) {
    seenRow = seenRow || {};
    return Promise.all(urls.map(function (url) {
      return fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (pages) {
      pages.forEach(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var list = doc.querySelector('[data-atcp-recs-list]');
        if (list) appendCards(list, track, seenRow);
      });
      if (track.children.length) { block.removeAttribute('hidden'); hydrateCards(track); }
      return track.children.length > 0;
    });
  }

  function recsUrl() {
    if (!item || !item.product_id) return '';
    return '/recommendations/products?section_id=' + CARDS_SECTION + '&intent=related&limit=12&product_id=' + encodeURIComponent(item.product_id);
  }

  // Derive the product handle from the stored item (handle, or from its URL).
  function itemHandle() {
    if (!item) return '';
    if (item.handle) return item.handle;
    if (item.url) {
      var m = item.url.split('?')[0].match(/\/products\/([^\/]+)/);
      if (m) return m[1];
    }
    return '';
  }

  // Learn the added product's primary collection / vendor / type, then fill blocks.
  function getSeed() {
    var handle = itemHandle();
    if (!handle) return Promise.resolve(null);
    return fetch('/products/' + encodeURIComponent(handle) + '?section_id=atc-seed', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (t) {
        // The section-render response may be wrapped in markup; pull the JSON out.
        try { return JSON.parse(t.trim()); } catch (e) {}
        var m = t.match(/\{[\s\S]*\}/);
        if (m) { try { return JSON.parse(m[0]); } catch (e2) {} }
        return null;
      })
      .catch(function () { return null; });
  }

  getSeed().then(function (seed) {
    seed = seed || {};
    var vendor = seed.vendor || (item && item.vendor) || '';
    var type = seed.type || (item && item.product_type) || '';
    var coll = seed.collection || '';

    // Never recommend the product that was just added.
    var added = itemHandle();

    // A fresh per-row de-dupe set, pre-seeded with the just-added product.
    function newRow() {
      var s = {};
      if (added) s[added] = true;
      return s;
    }

    function populate(block) {
      var mode = block.getAttribute('data-atcp-mode');
      var track = block.querySelector('[data-atcp-track]');
      if (!track) return Promise.resolve();

      if (mode === 'more_items') {
        // Same (most specific) collection, topped up with related
        // recommendations so the row is full even for a small collection.
        var miColl = coll ? '/collections/' + encodeURIComponent(coll) + '?section_id=' + CARDS_SECTION : null;
        return fetchFill([miColl, recsUrl()], track, block, newRow());

      } else if (mode === 'related') {
        // Same brand + type via a precise vendor/type search, topped up with
        // related recommendations (also covers filters being unavailable).
        var terms = [];
        if (vendor) terms.push('vendor:' + JSON.stringify(vendor));
        if (type) terms.push('product_type:' + JSON.stringify(type));
        var searchUrl = terms.length
          ? '/search?section_id=' + CARDS_SECTION + '&type=product&q=' + encodeURIComponent(terms.join(' '))
          : null;
        return fetchFill([searchUrl, recsUrl()], track, block, newRow());

      } else if (mode === 'best_sellers') {
        // Best-selling from the added product's collection first, then top up
        // with store-wide best sellers so the row isn't left short.
        var bsColl = coll ? '/collections/' + encodeURIComponent(coll) + '?section_id=' + CARDS_SECTION + '&sort_by=best-selling' : null;
        var bsAll = '/collections/all?section_id=' + CARDS_SECTION + '&sort_by=best-selling';
        return fetchFill([bsColl, bsAll], track, block, newRow());

      } else if (mode === 'browsing_collections') {
        var cols = getJSON(localStorage, COLL_KEY) || [];
        var pick = null;
        for (var i = 0; i < cols.length; i++) { if (cols[i] && cols[i] !== coll) { pick = cols[i]; break; } }
        pick = pick || cols[0];
        var pickUrl = pick ? '/collections/' + encodeURIComponent(pick) + '?section_id=' + CARDS_SECTION : null;
        // No (usable) browsing history: fall back to related recommendations.
        return fetchFill([pickUrl, recsUrl()], track, block, newRow());

      } else if (mode === 'recently_viewed') {
        // Handles come from localStorage, so no collection or search describes this
        // row. Ask the card section for one product at a time and let it render the
        // theme's product card, exactly as the other rows do - which is what gives
        // these cards a working Add to cart, variant picker and licence gating.
        var rowSeen = newRow();
        var handles = [];
        (getJSON(localStorage, RECENT_KEY) || []).forEach(function (p) {
          if (!p || !p.handle || rowSeen[p.handle]) return;
          rowSeen[p.handle] = true;
          handles.push(p.handle);
        });
        if (!handles.length) return Promise.resolve();
        return fetchAllOrdered(handles.slice(0, TARGET).map(function (h) {
          return '/products/' + encodeURIComponent(h) + '?section_id=' + CARDS_SECTION;
        // A fresh seen-set for the append pass: rowSeen now holds every handle we are
        // about to render, so reusing it would reject all of them. Both are seeded
        // with the just-added product, which this row never repeats.
        }), track, block, newRow());
      }
      return Promise.resolve();
    }

    // Each block fills independently (per-row de-dupe), so all rows populate.
    $$('[data-atcp-block]').forEach(function (block) { populate(block); });
  });

})();
